import React from 'react';

// styles
import {
  LabelContentWrapper,
  TextWrapper,
} from './LabelContentHorizontal-styles';
import {TextColors, TextDefault} from '../../styles';

// types
type Props = {
  label: string;
  content: string;
  isFullWidth?: boolean;
};

const LabelContentHorizontal = ({label, content, isFullWidth}: Props) => {
  return (
    <LabelContentWrapper>
      <TextWrapper isFullWidth={isFullWidth}>
        <TextDefault color={TextColors.secondary}>{label}</TextDefault>{' '}
      </TextWrapper>
      <TextWrapper isFullWidth={isFullWidth}>
        <TextDefault bold="bold">{content}</TextDefault>
      </TextWrapper>
    </LabelContentWrapper>
  );
};

export default LabelContentHorizontal;
